import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Table, Column, Cell } from 'fixed-data-table-2';
import TextCell from '../../TextCell/TextCell';
import { DateType } from '../../../containers/UIhelper/UIDateFormater';
import * as endPoints from '../../../constants/EndPoints';
import { downloadFileFromURl } from '../../../actions/selectors';

require('fixed-data-table-2/dist/fixed-data-table.css');
require('./UltraDeviceLogsTab.scss');

const _ = require('lodash');

class UltraDeviceLogsTab extends React.Component {
  constructor(props) {
    super(props);

    this.onRowClick = this.onRowClick.bind(this);
    this.rowClassNameGetter = this.rowClassNameGetter.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  onRowClick(_, rowIndex) {
    if (this.props.selectUltraLog) {
      this.props.selectUltraLog(this.props.ultraLogs[rowIndex]);
    }
  }

  rowClassNameGetter(rowIndex) {
    const { selectedUltraLog, ultraLogs } = this.props;
    return (selectedUltraLog && ultraLogs && ultraLogs[rowIndex]
         && selectedUltraLog.ID == ultraLogs[rowIndex].ID) ? 'active-row' : '';
  }

  async handleDownload(item, e) {
    e.stopPropagation();

    if (!item.s3_bucket || !item.s3_key) {
      return;
    }

    try {
      const { user } = this.props;
      if (!user) {
        return;
      }

      const token = await user.getIdToken();
      const url = `${endPoints.END_POINT}/signedfile?bucket=${encodeURIComponent(item.s3_bucket)}&key=${encodeURIComponent(item.s3_key)}`;

      const response = await fetch(url, {
        headers: {
          'token': token,
          'x-do-compression': true
        }
      });

      const data = await response.json();

      if (data.data) {
        const fileName = item.s3_key.substring(item.s3_key.lastIndexOf('/') + 1);
        downloadFileFromURl(data.data, fileName);
      }
    } catch (error) {
      // Silently fail - user will notice file didn't download
    }
  }

  render() {
    const { ultraLogs, uiInfo, timeZone } = this.props;

    let pWidth = 0.395 * (uiInfo.pageWidth - 10);
    let pHeight = 0.494 * uiInfo.pageHeight;

    const data = (ultraLogs != null && !_.isEmpty(ultraLogs)) ? ultraLogs : [];

    return (
      <div className="ultra-device-logs-tab">
        <Table
          rowsCount={data.length}
          width={pWidth}
          onRowClick={this.onRowClick}
          rowClassNameGetter={this.rowClassNameGetter}
          maxHeight={pHeight - 117}
          headerHeight={46}
          rowHeight={30}>

          <Column
            columnKey="block_start_datetime"
            header={<Cell>{this.context.t('block_start_datetime')}</Cell>}
            cell={<TextCell data={data} field="block_start_datetime" additional={timeZone} dateType={DateType.DATE_AND_TIME} />}
            width={30}
            flexGrow={1}
          />

          <Column
            columnKey="block_end_datetime"
            header={<Cell>{this.context.t('block_end_datetime')}</Cell>}
            cell={<TextCell data={data} field="block_end_datetime" additional={timeZone} dateType={DateType.DATE_AND_TIME} />}
            width={30}
            flexGrow={1}
          />

          <Column
            columnKey="block_send_datetime"
            header={<Cell>{this.context.t('block_send_datetime')}</Cell>}
            cell={<TextCell data={data} field="block_send_datetime" additional={timeZone} dateType={DateType.DATE_AND_TIME} />}
            width={30}
            flexGrow={1}
          />

          <Column
            columnKey="app_version"
            header={<Cell>{this.context.t('app_version')}</Cell>}
            cell={<TextCell data={data} field="app_version" />}
            width={20}
            flexGrow={1}
          />

          <Column
            columnKey="log_version"
            header={<Cell>{this.context.t('log_version')}</Cell>}
            cell={<TextCell data={data} field="log_version" />}
            width={20}
            flexGrow={1}
          />

          <Column
            columnKey="download"
            width={15}
            flexGrow={1}
            header={<Cell>{this.context.t('download')}</Cell>}
            cell={(props) => {
              const item = data[props.rowIndex];
              const hasFile = item.s3_bucket && item.s3_key;

              return (
                <Cell {...props}>
                  {hasFile ? (
                    <button
                      className="btn-download"
                      onClick={(e) => this.handleDownload(item, e)}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#337ab7',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        padding: 0
                      }}
                    >
                      {this.context.t('download')}
                    </button>
                  ) : (
                    <span style={{ color: '#999' }}>-</span>
                  )}
                </Cell>
              );
            }}
          />
        </Table>

        {data.length === 0 && (
          <div className="empty-state" style={{
            textAlign: 'center',
            padding: '20px',
            color: '#999'
          }}>
            {this.context.t('no_ultra_logs_available')}
          </div>
        )}
      </div>
    );
  }
}

UltraDeviceLogsTab.propTypes = {
  ultraLogs: PropTypes.array,
  uiInfo: PropTypes.object,
  timeZone: PropTypes.string,
  selectUltraLog: PropTypes.func,
  selectedUltraLog: PropTypes.object,
  user: PropTypes.object
};

UltraDeviceLogsTab.contextTypes = {
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {
    user: state.user.user
  };
};

export default connect(mapStateToProps)(UltraDeviceLogsTab);
